module.exports = __webpack_public_path__ + "img/x-Tm.5a37fc29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Tm.jpg
// module id = jevS
// module chunks = 1